import { DocumentError } from '@jeraisonne/documents';
import { documentsClient } from '@/lib/documents/queries';
import { openDocumentUrl } from '@/lib/documents/open';

/**
 * Ouvre un document connu par son seul `id` (ex. un message-fichier du dialogue
 * d'un rendez-vous). La ligne est relue sous RLS : un fichier supprimé — ou dont
 * l'accès est perdu — lève une erreur claire au lieu d'ouvrir un onglet vide.
 */
export async function openDocumentById(documentId: string): Promise<void> {
  await openDocumentUrl(async () => {
    const doc = await documentsClient.getById(documentId);
    if (!doc) throw new DocumentError('sign_failed', 'Ce fichier a été supprimé.');
    return documentsClient.signedUrl(doc.storagePath);
  });
}
